import React from 'react';
import propsComparator from '../../../utils/props-comparator';
import { Orientation } from '../types';

import './RangeSlider.scss';

declare module 'react' {
  interface HTMLAttributes<T> extends DOMAttributes<T> {
    orient?: string;
  }
}

export interface RangeSliderProps {
  min?: number;
  max?: number;
  value?: number;
  size?: string | number;
  orient?: Orientation;
  containerStyle?: object;
  onChange?: (event: React.ChangeEvent<HTMLElement>, state: any) => void;
}

export interface RangeSliderState {
  value: number,
  min: number,
  max: number,
  orient: Orientation,
  size: number | string
}

export default class RangeSlider extends React.Component<RangeSliderProps, RangeSliderState> {

  state = {
    value: this.props.value ?? this.props.min ?? 0,
    min: this.props.min ?? 0,
    max: this.props.max ?? 100,
    orient: this.props.orient ?? 'horizontal',
    size: this.props.size ?? '100%'
  }

  constructor(props: RangeSliderProps) {
    super(props);
    if (this.state.value < this.state.min) {
      this.state.value = this.state.min;
    }
    if (this.state.value > this.state.max) {
      this.state.value = this.state.max;
    }
  }

  render() {
    const size = this.getSize();
    let base = { position: 'relative', width: '100%' };
    if (this.state.orient === 'vertical') {
      base = { ...base, ...{ height: size, width: '20px', margin: 'auto' } };
    }
    return (
      <div style={base as any}>
        <div className={this.formatClasses()} style={this.getContainerStyle()}>
          <input
            type="range"
            max={this.state.max}
            min={this.state.min}
            value={this.state.value}
            onChange={this.onValueChange}
            style={this.inputStyle() as any}
            className="range-slider-input"
          />
        </div>
      </div>
    );
  }

  protected onValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const updated: any = {};
    updated.value = Number(event.target.value);
    if (updated.value < this.state.min) {
      updated.value = this.state.min;
    }
    if (updated.value > this.state.max) {
      updated.value = this.state.max;
    }
    this.setState({ value: Number(event.target.value) }, this.changeEventCallback(event));
  }

  protected formatClasses = () => {
    return 'range-slider orient-' + this.props.orient;
  }

  protected getSize = () => {
    return (
      typeof this.state.size === 'number' ?
        this.state.size + 'px' :
        (this.state.orient === 'vertical') ? '150px' : this.state.size
    );
  }

  protected getContainerStyle = () => {
    if (this.props.containerStyle) {
      return {
        ...this.props.containerStyle
      };
    }
    return {};
  }

  protected inputStyle = () => {
    if (this.state.orient === 'horizontal') {
      return { width: this.getSize() };
    }
    return {
      width: this.getSize(),
      position: 'absolute',
      left: 0,
      top: 0,
      transform: 'translateY(-50%)'
    }
  }

  changeEventCallback = (event: any) => {
    return () => {
      if (this.props.onChange) {
        this.props.onChange(event, this.state);
      }

      if (this.state.value > this.state.max) {
        this.setState({ value: this.state.max }, this.changeEventCallback(null));
      }
      if (this.state.value < this.state.min) {
        this.setState({ value: this.state.min }, this.changeEventCallback(null));
      }
    }
  }

  componentDidUpdate(prevProps: RangeSliderProps) {
    const keys = Object.keys(this.state);
    const update = propsComparator(keys, prevProps, this.props) as any;
    if (update) {
      this.setState(update as any, this.changeEventCallback(null));
    }
  }

}
